import type { Template } from "@/types";

export const PO_05_H3_V2: Template[] = [
    {
        id: "po-05-h3v2-01",
        name: "PO 01 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 32, y: 202, width: 289, height: 424, rotation: 0, imageRotation: 0 },
            { id: "2", x: 329, y: 202, width: 289, height: 424, rotation: 0, imageRotation: 0 },
            { id: "3", x: 751, y: 202, width: 452, height: 280, rotation: 0, imageRotation: 0 },
            { id: "4", x: 751, y: 490, width: 222, height: 136, rotation: 0, imageRotation: 0 },
            { id: "5", x: 981, y: 490, width: 222, height: 136, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-02",
        name: "PO 02 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 45, y: 153, width: 554, height: 334, rotation: 0, imageRotation: 0 },
            { id: "2", x: 45, y: 495, width: 273, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 326, y: 495, width: 272, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 202, width: 289, height: 424, rotation: 0, imageRotation: 0 },
            { id: "5", x: 978, y: 202, width: 289, height: 424, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-03",
        name: "PO 03 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 46, y: 139, width: 559, height: 356, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 46, y: 503, width: 134, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 471, y: 503, width: 133, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 188, y: 503, width: 275, height: 184, rotation: 0, imageRotation: 0 },
            { id: "5", x: 695, y: 236, width: 559, height: 356, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-04",
        name: "PO 04 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 31, y: 202, width: 289, height: 424, rotation: 0, imageRotation: 0 },
            { id: "2", x: 328, y: 202, width: 289, height: 424, rotation: 0, imageRotation: 0 },
            { id: "3", x: 700, y: 153, width: 273, height: 178, rotation: 0, imageRotation: 0 },
            { id: "4", x: 700, y: 339, width: 554, height: 335, rotation: 0, imageRotation: 0 },
            { id: "5", x: 981, y: 153, width: 273, height: 178, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-05",
        name: "PO 05 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 173, width: 368, height: 236, rotation: 0, imageRotation: 0 },
            { id: "2", x: 376, y: 173, width: 164, height: 236, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 417, width: 164, height: 237, rotation: 0, imageRotation: 0 },
            { id: "4", x: 172, y: 417, width: 368, height: 237, rotation: 0, imageRotation: 0 },
            { id: "5", x: 548, y: 173, width: 750, height: 481, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-06",
        name: "PO 06 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 232, width: 515, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 523, y: 232, width: 253, height: 363, rotation: 0, imageRotation: 0 },
            { id: "3", x: 784, y: 232, width: 252, height: 363, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1044, y: 232, width: 254, height: 177, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1044, y: 417, width: 254, height: 177, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-07",
        name: "PO 07 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 86, y: 131, width: 392, height: 563, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 486, y: 131, width: 433, height: 278, rotation: 0, imageRotation: 0 },
            { id: "3", x: 486, y: 417, width: 433, height: 277, rotation: 0, imageRotation: 0 },
            { id: "4", x: 927, y: 131, width: 283, height: 372, rotation: 0, imageRotation: 0 },
            { id: "5", x: 927, y: 512, width: 283, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-08",
        name: "PO 08 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 72, y: 113, width: 417, height: 600, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 497, y: 316, width: 305, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 497, y: 519, width: 305, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 810, y: 113, width: 418, height: 600, rotation: 0, imageRotation: 0 },
            { id: "5", x: 497, y: 113, width: 305, height: 195, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-09",
        name: "PO 09 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 232, width: 515, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 523, y: 232, width: 253, height: 363, rotation: 0, imageRotation: 0 },       
            { id: "3", x: 784, y: 232, width: 253, height: 178, rotation: 0, imageRotation: 0 },
            { id: "4", x: 784, y: 418, width: 253, height: 177, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1045, y: 232, width: 253, height: 363, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-10",
        name: "PO 10 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 72, y: 113, width: 417, height: 600, rotation: 0, imageRotation: 0 },
            { id: "2", x: 497, y: 113, width: 417, height: 600, rotation: 0, imageRotation: 0 },
            { id: "3", x: 922, y: 113, width: 305, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 922, y: 316, width: 305, height: 195, rotation: 0, imageRotation: 0 },
            { id: "5", x: 922, y: 519, width: 305, height: 194, rotation: 0, imageRotation: 0 }
        ],
    }
];